class Doubt {
  constructor(doubt) {
    this.doubtUID = doubt.uid;
    this.question = doubt.question;
    this.isActive = doubt.is_active;
    this.description = doubt.description;
    this.state = doubt.state;
    this.difficulty = doubt.difficulty_level;
    this.createdAt = doubt.created_at;
    this.updatedAt = doubt.updated_at;
    this.goal = { topology: doubt.goal };
    this.user = { user: doubt.user };
    this.topicGroup = doubt.topic_group
      ? { topology: doubt.topic_group }
      : null;
    this.topologies = doubt.topologies
      ? doubt.topologies.map((topology) => {
          return { topology };
        })
      : null;
  }
}

const getEntityData = (data) => {
  const doubt = new Doubt(data);
  return doubt;
};

export default {
  Doubt,
  getEntityData
};
